import CreateEditObjectsGroupForm from './component'

export default CreateEditObjectsGroupForm